//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import {appBaseUrl} from "../../utils/commons";
import manualSearch from '@/components/manual-search';
export default {
  name: "source-page",
  components: {DivSpan, manualSearch},
  data() {
    return {
      value: '',
      wrapperHeight: 0,
      allLoaded: false,
      show: true,
      page: 0,
      sourcingList: [],
      purorgList: [],
      classList: [],
      statusList: [{name:'全部',code:null,selected:true},{name:'新建/立项',code:'newSource'},{name:'报名/预审',code: 'enroll'},{name:'报价/投标',code:'offer'},{name:'报价已完成',code:'offerFinish'}],
      sourceClass: '',
      typeCode: null,
      purorgCode: '',
      codeSort: 'DESC',
      rules: [],
      rulesList: [],
      pageRules: {
        direction: "DESC",
        fromClientType: "pc",
        number: 0,
        property: "id",
        size: 10,
        rules: [],
        specialConditions: [],
        workflowSearchBean: {},
        ignoreField: true
      }
    }
  },
  methods: {
    getRules(e) {
      if(e.length){
        e.forEach(data=>{
          if (this.rules.length) {
            this.rules = this.rules.filter(val => val.field !== data.name)
          }
          if (data.code) {
            this.rules.push({field: data.name, option: data.option, values: [data.code]})
          }
        });
      }else{
        //重置菜单
        this.rules=[]
      }
      this.getSourcingList()
    },
    searchSourcing(searchData) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourceNum-sourceProject-executor.name-leader');
      }
      this.rules.push({
        field: "sourceNum-sourceProject-executor.name-leader",
        option: "LIKE_ANYWHERE",
        values: [searchData.key],
        collectIndex: -1
      });
      this.getSourcingList();
    },
    clear() {
      this.rules = this.rules.filter(val => val.field !== 'sourceNum-sourceProject-executor.name-leader');
      this.getSourcingList()
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      if (this.$store.state.device === 'wap') {
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top - 50;
      } else {
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top;
      }
    },
    initClassList() {
      this.classList = [];
      this.$get('api/sourceType/all').then(info => {
        for (let i = 0; i < info.length; i++) {
          let obj = {};
          obj.name = info[i].typeName;
          obj.code = info[i].editionId;
          this.classList.push(obj);
        }
        this.classList.unshift({name: '全部', code: null, selected: true});
      })
    },
    statusClick(code) {
      if(this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'stage')
      }
      if(code) {
        this.rules.push({field:"stage", option: "IN", values: [code] , collectIndex: -1})
      }
      this.getSourcingList();
    },
    joinStatusClick(item) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourcingType.typeCode')
      }
      if (item.value) {
        this.rules.push({field: "joinStatus", option: "IN", values: [item.value]})
      }
      this.page = 0;
      this.getSourcingList();
    },
    sourcingClassChange(e) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'sourceType.editionId')
      }
      if (e.code) {
        this.rules.push({field:"sourceType.editionId", option: "IN", values: [e.code]})
      }
      this.getSourcingList();
    },
    purorgOnChange(e) {
      if (this.rules.length) {
        this.rules = this.rules.filter(val => val.field !== 'purorg.purorgCode')
      }
      if (e.code) {
        this.rules.push({
          field: "purorg.purorgCode",
          option: "IN",
          values: [e.code]
        })
      }
      this.getSourcingList();
    },
    changeSort() {
      if (this.codeSort === 'DESC') {
        this.codeSort = 'ASC';
      } else {
        this.codeSort = 'DESC';
      }
      this.getSourcingList();
    },
    loadTop() {
      this.pageRules.number = 0;
      let rules = [];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/source/page', this.pageRules).then((list) => {
        this.sourcingList = list.content;
        this.pageRules.rules = [];
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.pageRules.number++;
      let rules = [];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/source/page', this.pageRules).then((list) => {
        this.sourcingList = this.sourcingList.concat(list.content);
        this.$loadingHide();
        this.pageRules.rules = [];
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$loadingHide();
      });

    },
    getSourcingList() {
      this.pageRules.number = 0;
      this.$loadingShow();
      let rules = [];
      if (this.rules.length) {
        this.pageRules.rules = [].concat(rules, this.rules)
      } else {
        this.pageRules.rules = rules;
      }
      this.$post('api/source/page', this.pageRules).then((list) => {
        this.show = false;
        this.$nextTick(() => {
          this.sourcingList = list.content;
          this.show = true;
        });
        this.pageRules.rules = [];
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //获取全部采购组织列表
    getPurorgList() {
      this.$loadingShow();
      this.$get('api/purorg').then((data) => {
        let list = [{code: null, name: '全部'}];
        if (data && data.length) {
          data.forEach(val => {
            if(val.enabled){
              list.push({name: val.purorgName, code: val.purorgCode});
            }
          })
        }
        this.$nextTick(() => {
          this.purorgList = list;
        });
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //跳转到详情页
    goSourceDetail(source) {
      this.$router.push(`/sources/${source.id}`);
    },
    //  初始加载
    initGetSourcingData() {
      this.getSourcingList();
    }
  },
  mounted() {
    this.init();
    this.initClassList();
  },
  created() {
    this.initGetSourcingData();
    this.getPurorgList();
  }
}



// WEBPACK FOOTER //
// ./src/page/home/source-page.vue